import React from "react";
import PageShell from "../components/layout/PageShell";
import LearnHero from "../features/learn/LearnHero";
import CourseGrid from "../features/learn/CourseGrid";
import CourseDetailSystem from "../features/learn/CourseDetailSystem";
import RoadmapSection from "../features/home/RoadmapSection";
import PlacementSection from "../features/home/PlacementSection";
import DashboardsSection from "../components/shared/DashboardsSection";
import SearchAssistant from "../components/shared/SearchAssistant";
import ContactSection from "../components/shared/ContactSection";
import LearningPaths from "../features/learn/LearningPaths";

export default function LearnPage() {
  return (
    <PageShell>
      <LearnHero />
      <CourseGrid />
      {/* <CourseDetailSystem /> */}
      {/* <RoadmapSection /> */}
      <PlacementSection />
      {/* <DashboardsSection /> */}
      <SearchAssistant />
      <ContactSection />
      {/* <LearningPaths /> */}
    </PageShell>
  );
}